import {Avatar} from 'shells/avatar/avatar';
import {IconAvatar} from 'shells/avatar/icon-avatar';
import {colors} from 'shells/colors/colors';
import {ParentCompanyIcon} from 'shells/icon';
import {CompanyRegularIcon} from 'shells/icon/svg/company-regular-icon';
import {PersonRoundRegularIcon} from 'shells/icon/svg/person-round-regular-icon';
import {Body} from 'shells/typography/body';

type Props = {
    avatarUrl?: string | null;
    hasUploadedAvatar: boolean;
    avatarType: 'accounts' | 'contacts';
    hasChildren?: boolean;
    name: string;
    contextOverview: React.ReactNode;
    isDeleted?: boolean;
};

export function PeepMiniHeaderTitle(props: Props) {
    const {hasChildren = false} = props;

    const avatarUrl = (props.avatarUrl ?? '').trim();
    const hasAvatarImage = props.hasUploadedAvatar && avatarUrl;

    function getIcon() {
        switch (props.avatarType) {
            case 'contacts':
                return PersonRoundRegularIcon;
            case 'accounts':
                return hasChildren && NutClientConfig.hasAccountHierarchy
                    ? ParentCompanyIcon
                    : CompanyRegularIcon;
            default:
                return undefined;
        }
    }

    return (
        <div className='flex min-width-0 align-center gap-8'>
            {hasAvatarImage ? (
                <Avatar avatarUrl={avatarUrl} type={props.avatarType} size={32} />
            ) : (
                <IconAvatar
                    icon={getIcon()}
                    avatarSize={32}
                    iconSize={20}
                    backgroundColor={
                        props.avatarType === 'contacts' ? colors.blueBg : colors.plumBg
                    }
                    iconColor={props.avatarType === 'contacts' ? colors.blueDk : colors.company}
                />
            )}
            <div className='flex flex-dir-col gap-2 min-width-0'>
                <Body
                    size='large'
                    color='dark'
                    isBold={true}
                    strikethrough={props.isDeleted}
                    truncate={{type: 'inline'}}
                >
                    {props.name}
                </Body>
                {props.contextOverview}
            </div>
        </div>
    );
}
